/* eslint-disable camelcase */
/* eslint-disable lines-between-class-members */

class QuickCustomer implements MerchantosQuickCustomer {
  lastUpdate: number;
  updateScheduled: number;
  keyPressTimer: number;
  lastSearchFields: string[] | null;
  lastResult: AjaxFormsResponse | null;

  constructor() {
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'null' is not assignable to type 'number'.
    this.lastUpdate = null;
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'null' is not assignable to type 'number'.
    this.updateScheduled = null;
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'null' is not assignable to type 'number'.
    this.keyPressTimer = null;
    this.lastSearchFields = null;
    this.lastResult = null;

    $(document)
      .off('.quick-customer')
      .on('keyup.quick-customer', '.create-quick-customer input', (event) =>
        this.keyUpFindResults(event)
      )
      .on('change.quick-customer', '.create-quick-customer input', () =>
        this.onChangeFindResults()
      );
  }

  /**
   * See if enough time has elapsed since the last update request, if not schedule an update if one isn't already scheduled
   *
   * @return true if an update is needed, false otherwise.
   */
  timeForUpdate = () => {
    if (!this.lastUpdate) {
      return true;
    }
    // get time since last time we did an update request
    const diff = new Date().getTime() - this.lastUpdate;

    // we only want to send an update every 1500 seconds
    if (diff >= 1500) {
      return true;
    }
    // we've updated recently so schedule an update, but only if no update is already scheduled
    if (this.updateScheduled) {
      return false;
    }
    // schedule to fire again in <diff> milliseconds
    this.updateScheduled = window.setTimeout(() => this.updateFind(), 1500 - diff);
    return false;
  };

  /**
   * Trigger an update with time limitations
   *
   * @return true if an update is done
   */
  updateFindLimited = () => {
    if (!this.timeForUpdate()) {
      return false;
    }
    return this.updateFind();
  };

  /**
   * Key up event on a field that dynamically updates the results, makes sure that we only send an update if the user has paused 750ms between keystrokes
   * If the field is a phone number, we only allow the xhr to proceed when we have 4+ characters typed
   * If the field is NOT a phone number, we only allow the xhr to proceed when we have 3+ characters typed
   *
   * @return {void}
   */
  keyUpFindResults = (event: JQuery.TriggeredEvent) => {
    clearTimeout(this.keyPressTimer);

    // Phone Number is 4+ chars, other fields 3+ chars : to allow the xhr to proceed
    let minLength = 3;
    if (event.target.type === 'tel') {
      minLength = 4;
    }

    if (event.target.value.length >= minLength) {
      this.keyPressTimer = window.setTimeout(() => this.updateFindLimited(), 750);
    }
  };

  /**
   * On change event for a field that dynamically updates the results. We always fire an update if this happens (rate limited).
   *
   * @return true
   */
  onChangeFindResults = () => {
    this.updateFindLimited();
    return true;
  };

  checkIfCustomerInputsEmpty = (inputValueArr: string[]) => {
    if (inputValueArr.every((val) => val === '')) {
      window.flashNotifier(
        'warning',
        'Unable to create new work order. Add a customer and try again.',
        5
      );
      return false;
    }

    return true;
  };

  /**
   * Update the dynamic customer search area with by searching on the customer fields that have been filled in
   *
   * @return true if an update is done, false if no update is done - because an update was done recently - in that case an update is scheduled
   */
  updateFind = () => {
    if (this.updateScheduled) {
      clearTimeout(this.updateScheduled);
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'null' is not assignable to type 'number'.
      this.updateScheduled = null;
    }
    this.lastUpdate = new Date().getTime();

    const contentMap = {} as ContentMap;
    contentMap.method = 'POST';
    contentMap.form_name = 'quick_customer.update_find';

    let diff = false;

    const findWithFields = [
      'f_name',
      'l_name',
      'phone_home',
      'phone_work',
      'mobile',
      'email',
      'email2',
      'dob',
      'customer_type_id',
      'address1',
      'address2',
      'city',
      'state',
      'zip',
      'country',
    ];
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < findWithFields.length; i++) {
      const input = $(`.create-quick-customer [name='${findWithFields[i]}']:last`)[0];
      if (input) {
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | { [key: string]: string... Remove this comment to see the full error message
        const value = window.merchantos.utils.stringTrim(window.getFormFieldValue(input));
        // @ts-expect-error ts-migrate(7015) FIXME: Element implicitly has an 'any' type because index... Remove this comment to see the full error message
        if (this.lastSearchFields && this.lastSearchFields[findWithFields[i]] !== value) {
          diff = true;
        }
        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        contentMap[findWithFields[i]] = value;
      }
    }

    if (this.lastResult && !diff) {
      // no difference from last time we searched so just use the last result we got
      // merchantos.quick_customer.ajaxQuickCustomer_Return(this.lastResult); we already have this displayed so we don't need to re-display it
      return true;
    }

    this.lastSearchFields = [];
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < findWithFields.length; i++) {
      // @ts-expect-error ts-migrate(7015) FIXME: Element implicitly has an 'any' type because index... Remove this comment to see the full error message
      this.lastSearchFields[findWithFields[i]] = contentMap[findWithFields[i]];
    }

    window.doServerCall(contentMap, this.ajaxQuickCustomer_Return);
    return true;
  };

  /**
   * Create a new customer from the customer search fields
   *
   * @return true
   */
  createCustomer = () => {
    const contentMap = {} as ContentMap;
    contentMap.method = 'POST';
    contentMap.form_name = 'quick_customer.create_customer';

    const findWithFields = [
      'f_name',
      'l_name',
      'phone_home',
      'phone_work',
      'mobile',
      'email',
      'email2',
      'dob',
      'customer_type_id',
      'address1',
      'address2',
      'city',
      'state',
      'state_code',
      'zip',
      'country',
      'country_code',
    ];

    const inputValueArr = [];

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < findWithFields.length; i++) {
      const input = $(`.create-quick-customer [name='${findWithFields[i]}']:last`)[0];
      if (input) {
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | { [key: string]: string... Remove this comment to see the full error message
        const value = window.merchantos.utils.stringTrim(window.getFormFieldValue(input));

        // 'customer_type_id' returns a '0' for "None" (not selected)
        if (input.getAttribute('type') !== 'hidden' && value !== '0') inputValueArr.push(value);

        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        contentMap[findWithFields[i]] = value;
      }
    }

    const inputsCheck = this.checkIfCustomerInputsEmpty(inputValueArr);
    if (!inputsCheck) return false;

    window.doServerCall(contentMap, this.ajaxQuickCustomer_Return);
    return true;
  };

  /**
   * Look for the hidden input 'quickCustomerAttach' and use the value as a function name to call as the attachcustomer function
   *
   * @param integer customerId The customer record id to attach
   * @return the result of the dynamic attachCustomer function. false if no dynamic function is defined.
   */
  attachCustomer = (customerId: number) => {
    const quickCustomerAttach = $('#quick_customer_attach');
    if (quickCustomerAttach.length) {
      quickCustomerAttach.val(customerId).trigger('change');
    }
  };

  /**
   * Function called by .bind after ajax response is received
   *
   * @param array result the array of result fields
   */
  ajaxQuickCustomer_Return = (result: AjaxFormsResponse) => {
    if (result.find_results) {
      const findResults = $('.workorder-customer-matches');
      if (findResults) {
        findResults.replaceWith(result.find_results);
      }
      this.lastResult = result;
    }

    if (result.customer_id) {
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
      this.attachCustomer(result.customer_id);
    }
  };
}

window.merchantos.quick_customer = new QuickCustomer();
